'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'toilets-portable';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e584';
var svgPathData = 'M64 32l128 0c17.7 0 32 14.3 32 32l0 32L32 96l0-32c0-17.7 14.3-32 32-32zM32 448l0-320 192 0 0 80-24 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l24 0 0 112L32 448zM256 208l0-144c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 192 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 0-32 0-64 0-32zm-32 32l0 64-24 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l24 0zM384 32l128 0c17.7 0 32 14.3 32 32l0 32L352 96l0-32c0-17.7 14.3-32 32-32zM352 448l0-320 192 0 0 80-24 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l24 0 0 112-192 0zM576 208l0-144c0-35.3-28.7-64-64-64L384 0c-35.3 0-64 28.7-64 64l0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 192 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 0-32 0-64 0-32zm-32 32l0 64-24 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l24 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faToiletsPortable = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;